/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_ParticipantTask_AuditTrailsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_AuditTrailsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_CheckBlackoutDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_CheckBlackoutDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodSettingDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodSettingDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_OptionAwardAcceptDetailsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_OptionAwardAcceptDetailsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantCurrentCashBalanceDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantCurrentCashBalanceDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PendingPSUAwardDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PendingPSUAwardDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PendingPSUElectAwardDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PendingPSUElectAwardDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUAwardDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUAwardDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUElectAwardDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUElectAwardDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PsuAwardAcceptDetailsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PsuAwardAcceptDetailsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PSUElectionMethodDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PSUElectionMethodDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_RsuAwardAcceptDetailsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_RsuAwardAcceptDetailsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_SarAwardAcceptDetailsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_SarAwardAcceptDetailsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_TotalValueDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_TotalValueDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_WarrantAwardAcceptDetailsDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_WarrantAwardAcceptDetailsDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantTaskSharedService {

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUAwardDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskPendingRSuAwards(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUAwardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/pending-rSUAwards',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUElectAwardDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskPendingRSuElectAwards(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_PendingRSUElectAwardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/pending-rSUElect-awards',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodSettingDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskRSUElectionMethodSetting(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodSettingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/r-sUElection-method-setting',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskAcceptPSuAward(
formData?: {
Id: string;
Signature: string;
AcceptedDate?: string;
'Document.File'?: Blob;
'Document.AwardId'?: string;
'Document.Tenantid'?: string;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/accept-pSUAward',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskAcceptRSuAward(
formData?: {
Id: string;
Signature: string;
AcceptedDate?: string;
'Document.File'?: Blob;
'Document.AwardId'?: string;
'Document.Tenantid'?: string;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/accept-rSUAward',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PendingPSUAwardDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskPendingPSuAwards(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_PendingPSUAwardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/pending-pSUAwards',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PendingPSUElectAwardDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskPendingPSuElectAwards(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_PendingPSUElectAwardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/pending-pSUElect-awards',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodSettingDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskPSUElectionMethodSetting(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodSettingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/p-sUElection-method-setting',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodSettingDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskOptionsElectionMethodSetting(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodSettingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/options-election-method-setting',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuVestingDateId 
     * @param settlementTypeId 
     * @param settlementType 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskElectionMethod(
rsuVestingDateId?: string,
settlementTypeId?: string,
settlementType?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_ElectionMethodDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/election-method',
            query: {
                'RSUVestingDateId': rsuVestingDateId,
                'SettlementTypeId': settlementTypeId,
                'SettlementType': settlementType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuVestingDateId 
     * @param settlementTypeId 
     * @param settlementType 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PSUElectionMethodDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskPsuElectionMethod(
psuVestingDateId?: string,
settlementTypeId?: string,
settlementType?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_PSUElectionMethodDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/psu-election-method',
            query: {
                'PSUVestingDateId': psuVestingDateId,
                'SettlementTypeId': settlementTypeId,
                'SettlementType': settlementType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskCheckTradePreClearanceOrBlackout(
rsuVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/check-trade-pre-clearance-or-blackout/{rsuVestingDateId}',
            path: {
                'rsuVestingDateId': rsuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_CheckBlackoutDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskCheckBlackout(
rsuVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_CheckBlackoutDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/check-blackout/{rsuVestingDateId}',
            path: {
                'rsuVestingDateId': rsuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskCheckPsuTradePreClearanceOrBlackout(
psuVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/check-psu-trade-pre-clearance-or-blackout/{psuVestingDateId}',
            path: {
                'psuVestingDateId': psuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_CheckBlackoutDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskCheckPsuBlackout(
psuVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_CheckBlackoutDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/check-psu-blackout/{psuVestingDateId}',
            path: {
                'psuVestingDateId': psuVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskUpComingEvents(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_UpComingEventsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/up-coming-events',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_AuditTrailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskAuditTrails(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_AuditTrailsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/audit-trails',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_TotalValueDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskTotalValue(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_TotalValueDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/total-value',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskHoldingDetails(
companyId: string,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/holding-details/{CompanyId}',
            path: {
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param rsuAwardId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_RsuAwardAcceptDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskRSUAwardAcceptDetails(
rsuAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_RsuAwardAcceptDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/r-sUAward-accept-details/{RsuAwardId}',
            path: {
                'RsuAwardId': rsuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param psuAwardId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PsuAwardAcceptDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskPSUAwardAcceptDetails(
psuAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_PsuAwardAcceptDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/p-sUAward-accept-details/{PsuAwardId}',
            path: {
                'PsuAwardId': psuAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_OptionAwardAcceptDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskOptionAwardAcceptDetails(
optionAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_OptionAwardAcceptDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/option-award-accept-details/{OptionAwardId}',
            path: {
                'OptionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskAcceptOptionAward(
formData?: {
Id: string;
Signature: string;
AcceptedDate?: string;
'Document.File'?: Blob;
'Document.AwardId'?: string;
'Document.Tenantid'?: string;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/accept-option-award',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param warrantId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_WarrantAwardAcceptDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskWarrantAwardAcceptDetails(
warrantId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_WarrantAwardAcceptDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/warrant-award-accept-details/{warrantId}',
            path: {
                'warrantId': warrantId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskAcceptWarrantAward(
formData?: {
Id: string;
Signature: string;
AcceptedDate?: string;
'Document.File'?: Blob;
'Document.AwardId'?: string;
'Document.Tenantid'?: string;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/accept-warrant-award',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionVestingDateId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskCheckTradePreClearanceOrBlackoutForExercise(
optionVestingDateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/check-trade-pre-clearance-or-blackout-for-exercise/{optionVestingDateId}',
            path: {
                'optionVestingDateId': optionVestingDateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param optionAwardId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskCheckTradePreClearanceOrBlackoutForExerciseByAwardId(
optionAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_CheckTradePreClearanceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/check-trade-pre-clearance-or-blackout-for-exercise-by-award-id/{optionAwardId}',
            path: {
                'optionAwardId': optionAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantCurrentCashBalanceDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskParticipantCurrentCashBalance(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_ParticipantCurrentCashBalanceDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/participant-current-cash-balance',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sarAwardId 
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_SarAwardAcceptDetailsDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppParticipantTaskSarAwardAcceptDetails(
sarAwardId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_SarAwardAcceptDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/participant-task/sar-award-accept-details/{sarAwardId}',
            path: {
                'sarAwardId': sarAwardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppParticipantTaskAcceptSarAward(
formData?: {
Id: string;
Signature: string;
AcceptedDate?: string;
'Document.File'?: Blob;
'Document.AwardId'?: string;
'Document.Tenantid'?: string;
},
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/participant-task/accept-sar-award',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
